import React, { useEffect, useState } from 'react'
import Header from '../../comps/Header'
import Footer from '../../comps/Footer'
import PageMainBanner from '../../comps/PageMainBanner'
import { useLocation, useParams } from 'react-router-dom'
import { get_blog_details, get_main_banner_section } from '../../api/Global'
import { IMG_BASE_URL } from '../../config/Base_Url_Config'
import contact_support from "../../assets/images/contact-support.png"

const Blog_Details = () => {
      const { id } = useParams();
      const [knowledge_details, setKnowledge_Details] = useState([]);
      const [get_banner_list, set_Banner_List] = useState([]);

      // // <------------- handle date and time formate -------------->
      const formatDate = (dateString) => {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' });
      };

      // <---------- show the details of the Knowledge Details ----------->
      useEffect(() => {
            const handle_get_knowledge = async () => {
                  try {
                        const response = await get_blog_details(id);
                        setKnowledge_Details(response?.data?.data?.blogs)
                  }
                  catch (error) {
                        console.log("error during call the knowledge centers data", error)
                  }
            }
            handle_get_knowledge();
      }, [])

      // <----------- render the main banner section ---------->
      useEffect(() => {
            const handle_get_main_banner_section = async () => {
                  try {
                        const response = await get_main_banner_section();
                        set_Banner_List(response?.data?.data?.banners)
                  } catch (error) {
                        console.log("error", error)
                  }
            }
            handle_get_main_banner_section();
      }, [])

      return (
            <>
                  <Header />
                  <PageMainBanner heading="Blog" title={get_banner_list?.home_title} para={get_banner_list?.home_description} image={get_banner_list?.web_hosting_image ? `${IMG_BASE_URL}/${get_banner_list?.domain_image}` : { contact_support }} />
                  <section className="relative py-10 md:py-24">
                        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-transparent" />
                        <div className="mx-auto max-w-6xl px-6 lg:px-8">
                              {/* <div className="relative flex flex-wrap md:space-x-6 space-y-6 md:space-y-0 w-full mb-6">
                                    <div className="relative min-[1200px]:w-[100%] min-[1100px]:w-[100%] min-[992px]:w-[100%] flex min-[768px]:w-[100%] min-[576px]:w-[100%] bg-gray-50/50 rounded-xl p-6 border border-blue-900/10">
                                          <div>
                                                <div className="relative w-full rounded-lg overflow-hidden mb-4">
                                                      <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-500/20" />
                                                      <img
                                                            src={`${IMG_BASE_URL}/${knowledge_details?.image}`}
                                                            alt="Post"
                                                            className="w-full h-full object-cover"
                                                      />
                                                </div>


                                                <div className="flex flex-col justify-center items-start pt-3 md:pt-0">
                                                      <div className="flex items-center gap-4 mb-4"><span className="px-3 py-1 text-sm text-blue-400 bg-blue-500/10 rounded-full">Uncategorized</span>
                                                            <span className="text-sm text-gray-400"><i className="fa-regular fa-clock text-blue-500 mr-2" />{formatDate(knowledge_details?.created_at)}</span>
                                                            <span className="text-sm text-gray-400"><i className="fa-regular fa-comment text-blue-500 mr-2" /> 20</span>
                                                      </div>
                                                      <h2 className="text-2xl font-bold mb-4 line-clamp-2">{knowledge_details?.title}</h2>
                                                      <p className="text-gray-400 line-clamp-3 mb-6" dangerouslySetInnerHTML={{ __html: knowledge_details?.description }} />

                                                </div>
                                          </div>
                                    </div>

                              </div> */}
                              <div className="relative flex flex-wrap md:space-x-6 space-y-6 md:space-y-0 w-full mb-6">
                                    <div className="relative min-[1200px]:w-[100%] min-[1100px]:w-[100%] min-[992px]:w-[100%] min-[768px]:w-[100%] min-[576px]:w-[100%] bg-gray-50/50 rounded-xl p-6 border border-blue-900/10">
                                          <div>
                                                <div className="relative w-full h-[550px] rounded-lg overflow-hidden mb-4 flex items-center justify-center">
                                                      <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-500/20" />
                                                      <img
                                                            src={`${IMG_BASE_URL}/${knowledge_details?.image}`}
                                                            alt="Post"
                                                            className="w-full h-full"
                                                      />
                                                </div>


                                                <div className="flex flex-col justify-center items-start pt-3 md:pt-0">
                                                      <div className="flex items-center gap-4 mb-4">
                                                            {/* <span className="px-3 py-1 text-sm text-blue-400 bg-blue-500/10 rounded-full">Uncategorized</span> */}
                                                            <span className="text-sm text-gray-400"><i className="fa-regular fa-clock text-blue-500 mr-2" />{formatDate(knowledge_details?.created_at)}</span>
                                                            {/* <span className="text-sm text-gray-400"><i className="fa-regular fa-comment text-blue-500 mr-2" /> 20</span> */}
                                                      </div>
                                                      <h2 className="text-2xl font-bold mb-4 line-clamp-2">{knowledge_details?.title}</h2>
                                                      <p className="text-gray-400 mb-6" dangerouslySetInnerHTML={{ __html: knowledge_details?.description }} />

                                                </div>
                                          </div>
                                    </div>

                              </div>
                        </div>
                  </section>

                  <Footer />
            </>
      )
}

export default Blog_Details